import React from 'react'
import { CiSearch } from "react-icons/ci";

const SearchComponent = ({ onChange, value, placeholder, type }) => {
    return (

        <div className="flex items-center w-auto bg-white border border-gray-300 rounded-md shadow-sm p-2">
            <CiSearch className="h-5 w-5 text-gray-500 mr-2" />
            <input
                type={type ? type : 'text'}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className="w-full p-1 focus:outline-none"
            />
        </div>

    )
}

export default SearchComponent
